import { render, staticRenderFns } from "./HourStatistic.vue?vue&type=template&id=2229b0d2&scoped=true&"
import script from "./HourStatistic.vue?vue&type=script&lang=js&"
export * from "./HourStatistic.vue?vue&type=script&lang=js&"
import style0 from "./HourStatistic.vue?vue&type=style&index=0&id=2229b0d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2229b0d2",
  null
  
)

export default component.exports